module.exports = __webpack_public_path__ + "static/media/emoji_zoomed.99a8d5a3.png";